import React, { useEffect, useState } from "react";

//* ReactFlow Library
import ReactFlow, { useReactFlow, Controls, MiniMap, getNodesBounds, getViewportForBounds } from "reactflow";

import { toPng } from "html-to-image";

import {
  nodeTypes,
  edgesTypes,
  generateNodesData,
  generateEdgesData,
  getAllTeamsKeyVal,
  defaultEdgeOptions,
  defaultViewport,
  proOptions,
  hoverToHighlight,
  longTextHover,
} from "./utilities/helper";

const BracketView = (props) => {
  const brackets = props.bracket[0] || [];
  const hideSeed = props.hide_bracket_seed;
  const hasWorkingTeam = props.has_working_team;

  const titlesNode = props.titles || [];
  const bracketsData = brackets.map((bracket) => bracket[0]);
  const teamDataObj = Object.values(props.team_type);
  const allTeams = getAllTeamsKeyVal(props.all_teams);

  const { getNodes } = useReactFlow();
  const [image, setImage] = useState(null);

  useEffect(() => {
    //* Remove tooltip from the minimap
    document.getElementById("react-flow__minimap-desc-1").remove();
  }, []);

  //* Generate image after ReactFlow rendering is complete
  const generateImage = async () => {
    const imageWidth = 2480;
    const imageHeight = 3508;
    const nodesBounds = getNodesBounds(getNodes());
    const transform = getViewportForBounds(
      nodesBounds,
      imageWidth,
      imageHeight,
      0.5,
      7
    );

    const imageDataUrl = await toPng(document.querySelector(".react-flow__viewport"), {
      backgroundColor: "#fcfcfc",
      width: imageWidth,
      height: imageHeight,
      skipFonts: true,
      skipAutoScale: true,
      fetchRequestInit: {
        mode: 'no-cors'
      },
      style: {
        width: imageWidth,
        height: imageHeight,
        transform: `translate(${transform.x}px, ${transform.y}px) scale(${transform.zoom})`,
      },
    });
    
    setImage(imageDataUrl);
  };

  useEffect(() => {
    setTimeout(() => {
      hoverToHighlight();
      longTextHover();
      generateImage();
    }, 500);
  }, [nodes]);

  const nodes = generateNodesData(
    [...bracketsData, ...titlesNode],
    teamDataObj,
    allTeams,
    true,
    false,
    true,
    hideSeed,
    [],
    hasWorkingTeam
  );

  const edges = generateEdgesData(props.edges || []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 frontWrapper">
          <ReactFlow
            proOptions={proOptions}
            nodes={nodes}
            edges={edges}
            nodeTypes={nodeTypes}
            edgeTypes={edgesTypes}
            defaultViewport={defaultViewport}
            defaultEdgeOptions={defaultEdgeOptions}
            edgesFocusable={false}
            nodesFocusable={false}
            nodesDraggable={false}
            nodesConnectable={false}
            fitView
            panOnScroll
            minZoom={-Infinity}
          >
            <Controls showInteractive={false} />
            <MiniMap style={{ height: 120 }} zoomable pannable />
          </ReactFlow>
        </div>
        {image && <div id="bracket-image-container" style={{ display: 'none' }}>
          <img src={image} />
        </div>}
      </div>
    </div>
  );
};

export default BracketView;
